import { types } from 'mobx-state-tree';
import { ConfirmationTextsModel } from './confirmationTextsModel';

export const TextsConfigurationModel = types.model('TextsConfigurationModel', {
  applicationHeaderText: types.maybe(types.string),
  confirmationTexts: types.maybe(ConfirmationTextsModel)
});
